<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sLsusw/tc-custom/9780226220635.jpg?1734282299728" alt="This image is the cover for the book Evolution of Vertebrate Design"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Evolution of Vertebrate Design
      </h1>
      <p class="bookDescription body article font2">
        <i>The Evolution of Vertebrate Design</i> is a solid introduction to vertebrate evolution, paleontology, vertebrate biology, and functional, comparative anatomy. Its lucid style also makes it ideal for general readers intrigued by fossil history. Clearly drawn diagrams illustrate biomechanical explanations of the evolution of fins, jaws, joints, and body shapes among vertebrates. A glossary of terms is included.<br/><br/> "A luminous text is matched by lucid drawings rationally placed. . . . A great teaching monograph, the book will charm lay readers of fossil history. For virtually every college &amp; public collection."—<i>Scitech Book News</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leonard B. Radinsky
      </h2>
      
      <p class="authorDescription body article"><B>Leonard B. Radinsky</B>&#160;(1937–1985) was an American paleontologist and professor at the&#160;University of Chicago.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dafbd5fa